import { Doc } from 'tiptap'

export default class RegistBoardContent extends Doc {

  get schema() {
    return {
      content: 'block+',
    }
  }

}


// WEBPACK FOOTER //
// ./src/components/cowork/general/board/modal/RegistBoardContent.js